import { useSelector } from "react-redux";
import Select from "@material-ui/core/Select";
import { useTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import FlagIcon from "react-flag-kit/lib/FlagIcon";

import { cap } from "../../../utils/utils";

function InputLingoLanguages({ type, name, value, onChange, required, error }) {
  const { t } = useTranslation();
  const { allLingos } = useSelector((state) => state.genericReducer);

  return (
    <div className={`lineInput lineInput${type} lineInput${cap(name)} ${error ? "invalid" : ""}`}>
      <label htmlFor={name}>{t("LANGUAGE")}</label>
      {required && <span>{t("REQUIRED_FIELD")}</span>}
      <div className="select-wrapper">
        <Select
          name={name}
          displayEmpty
          value={value}
          disableUnderline
          className="lingoLanguageSelect"
          onChange={(e) => onChange(e, name)}
        >
          <MenuItem value={""}>{t("SELECT")}</MenuItem>
          {allLingos?.map((option) => (
            <MenuItem key={option.language.name} value={option.id}>
              <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: -3 }}>
                <FlagIcon code={option.flag} />
                <span className="lingoLanguageItem'">&nbsp;{option.language.name}</span>
                {/* <span className="lingoLanguageItem'">&nbsp;{t(option.language.name.toUpperCase())}</span> */}
              </div>
            </MenuItem>
          ))}
        </Select>
      </div>
    </div>
  );
}

export default InputLingoLanguages;
